import "./Autocomplete.scss";
import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

function ComboBox({
  autoCompleteOptions,
  autoCompleteLabel,
  onSearch,
  onSelect,
  value,
  width = 300,
}) {
  const [inputValue, setInputValue] = React.useState(value?.label || "");
  const [selectedValue, setSelectedValue] = React.useState(value || null);

  React.useEffect(() => {
    if (value) {
      setInputValue(value.label);
      setSelectedValue(value);
    }
  }, [value]);

  const highlightMatch = (text, query) => {
    if (!query) return <span>{text}</span>;
    const index = text.toLowerCase().indexOf(query.toLowerCase());
    if (index === -1) return <span>{text}</span>;
    const before = text.substring(0, index);
    const match = text.substring(index, index + query.length);
    const after = text.substring(index + query.length);
    return (
      <span>
        {before}
        <span style={{ color: "var(--primary-color)", backgroundColor: "var(--neutral-bg)" }}>{match}</span>
        {after}
      </span>
    );
  };

  return (
    <Autocomplete
      disablePortal
      options={autoCompleteOptions}
      sx={{ width }}
      inputValue={inputValue}
      value={selectedValue}
      noOptionsText={"Select Options"}
      ListboxProps={{ style: { maxHeight: 250 } }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
        if (onSearch) onSearch(newInputValue);
      }}
      onChange={(event, newValue) => {
        setSelectedValue(newValue);
        onSelect(newValue);
      }}
      renderOption={(props, option) => {
        const { key, ...restProps } = props;
        return (
          <li key={option.id} {...restProps} style={{ ...restProps.style, display: "block" }}>
            {highlightMatch(option.label, inputValue)}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField {...params} label={autoCompleteLabel} />
      )}
    />
  );
}

export default ComboBox;
